import { Component, OnInit, Inject, ViewChild, OnDestroy } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Profile, Company } from 'app/models';
import { ChangeProfilesService } from 'app/services';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { SelectionModel } from '@angular/cdk/collections';
import * as tableHelpers from 'app/helpers/tableSelectionHelpers';
import { environment } from 'environments/environment';



interface AddData {
  users: Profile[];
  title: string;
  branch: Company;
}

@Component({
  standalone: false,
  selector: 'app-add-user-to-branch-dialog',
  templateUrl: './add-user-to-branch-dialog.component.html',
  styleUrls: ['./add-user-to-branch-dialog.component.scss']
})
export class AddUserToBranchDialogComponent implements OnInit, OnDestroy {
  private paginator: MatPaginator;
  private sort: MatSort;
  displayedColumns = ['select', 'name', 'email'];
  dataSource = new MatTableDataSource([]);
  selection = new SelectionModel<Profile>(true, []);
  usersCount: number;
  branch: Company;
  public userSearchField = new FormControl();
  private onDestroy$ = new Subject<void>();
  currentPageUsers: Profile[];

  @ViewChild(MatPaginator, { static: false }) set matPaginator(
    mp: MatPaginator
  ) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatSort, { static: false }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AddData,
    private _changeProfilesService: ChangeProfilesService,
    public dialogRef: MatDialogRef<AddUserToBranchDialogComponent>
  ) {}


  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  subscribeToFormInput(): void {
    const searchInput$ = this.userSearchField.valueChanges.pipe(debounceTime(200));
    searchInput$.pipe(
      takeUntil(this.onDestroy$)
    ).subscribe(data => {
      const input = data?.trim();
      if (input.length >= environment.minimumSearchLength || input.length === 0) {
        this.handleSearch(input);
      }
    });      
  }

  ngOnInit() {
    this.dataSource.data = this.data.users;
    this.usersCount = this.data.users.length;
    this.dataSource
    .connect()
    .pipe(takeUntil(this.onDestroy$))
    .subscribe((users) => {
      this.currentPageUsers = users;
    });
    this.branch = this.data.branch;
    this.setDataSourceAttributes();
    this.subscribeToFormInput();
  }

  setDataSourceAttributes() {
    this.dataSource.data.sort((a, b) =>
      a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    );
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = tableHelpers.sortingDataAccessor;
  }
  handleSearch(data): void {
    this.dataSource.filter = data;
  }
  removeUser(user: Profile): void {
    const branchIndex: number = user.branchAssignments.findIndex(
      branch => branch === this.branch.accountId
    );
    if (branchIndex !== -1) {
      user.branchAssignments.splice(branchIndex, 1);
      this._changeProfilesService.removeUser(user);
    }
  }

  addUser(user: Profile): void {
    user.branchAssignments.push(this.branch.accountId);
    this._changeProfilesService.addUser(user);
  }

  monitorSearch(event) {
    this.userSearchField.setValue(event);
  }

  isAllSelected = () => tableHelpers.isAllSelected(this.currentPageUsers, this.selection.selected);

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle = () => tableHelpers.masterToggle(this.currentPageUsers, this.selection);

  isPartiallySelected = () => tableHelpers.isPartiallySelected(this.currentPageUsers, this.selection.selected);

  close(){
    this.selection.clear();
    this.dialogRef.close();
  }

  selectedUsers(){
    this.selection.selected.forEach((user) => 
    {
      user.branchAssignments.push(this.branch.accountId);
      this._changeProfilesService.addUser(user)
    })
  }

}
